import attachBlockListeners from './block.js';
import attachComponentListeners from './component.js';
import attachEditorListeners from './editor.js';
import attachKeymapListeners from './keymaps.js';
import attachSelectionListeners from './selection.js';
import attachStorageListeners from './storage.js';
import attachStyleListeners from './style.ts';

/**
 * Initialize listeners for the editor
 */

export default (opt = {}) => {
    attachBlockListeners(opt);
    attachComponentListeners(opt);
    attachEditorListeners(opt);
    attachKeymapListeners(opt);
    attachSelectionListeners(opt);
    attachStorageListeners(opt);
    attachStyleListeners(opt);
};
